module.exports = require('./helpers/bundle-url').getBundleURL('8noT4') + "annotation-severity-low-icon.a318221a.svg";